<template>
  <v-form ref="form">
    <div :class="'subheading ' + $vuetify.breakpoint.name">Informe os dados do selo</div>
    <v-layout wrap>
      <v-flex xs12 class="padded">
        <v-text-field label="Código do selo" v-model="codigoSelo" :mask="codigoMask"
                      :error="!codigoValido && this.touched.codigo" :suffix="codigoSuffix"
                      @keypress.enter="submit"
                      autofocus></v-text-field>
      </v-flex>
      <v-flex xs12 class="padded">
        <select-selo v-model="tipoSelo"></select-selo>
      </v-flex>
      <v-layout row class="text-xs-center" justify-space-around>
        <v-flex xs12 class="padded">
          <div style="z-index: 9999;" v-if="!captchaDelay">
            <vue-recaptcha ref="recaptcha" @verify="verifyCaptcha" @expired="resetCaptcha"
                           size="invisible" :sitekey="captcha_key" @render="showCaptchaBadge">
            </vue-recaptcha>
          </div>
          <v-btn id="submit" class="green lg white--text" :disabled="!canSubmit" @click="submit" block
                 large :loading="loading">Consultar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-form>
</template>

<script>
  import SelectSelo from './SelectSelo';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: "FormBuscaSelo",
    components: {
      'select-selo': SelectSelo,
      'vue-recaptcha': VueRecaptcha
    },
    data: function () {
      return {
        captcha_key: process.env.captcha_key,
        captchaBadge: false,
        codigoSelo: '',
        tipoSelo: undefined,
        touched: {
          codigo: false,
          tipoSelo: false
        },
        loading: false,
        captchaDelay: true
      };
    },
    watch: {
      tipoSelo: function () {
        this.touched.tipoSelo = true;
        this.resetCaptcha();
      },
      codigoSelo: function () {
        this.touched.codigo = true;
        this.resetCaptcha();
      }
    },
    computed: {
      codigoMask: function () {
        return this.tipoSelo === 9 ? 'NNNNNNNNNN-NNNNN' : 'NNNNNNNN';
      },
      codigoSuffix: function () {
        const len = this.codigoSelo.length;
        return this.tipoSelo === 9 ? `${len}/15` : `${len}/8`;
      },
      codigoValido: function () {
        const validaDigital = this.tipoSelo === 9 && this.codigoSelo.length === 15;
        const validaFisico = this.tipoSelo !== 9 && this.codigoSelo.length === 8
        return validaDigital || validaFisico;
      },
      tipoValido: function () {
        return this.tipoSelo !== undefined;
      },
      canSubmit: function () {
        return this.codigoValido && this.tipoValido;
      }
    },
    mounted: function () {
      let self = this;
      setTimeout(() => {
        self.captchaDelay = false;
      }, 800);
    },
    methods: {
      showCaptchaBadge: function () {
        setTimeout(function () {
          this.captchaBadge = true;
        }, 1000);
      },
      resetCaptcha: function () {
        if (this.captcha) {
          this.captcha = false;
          this.$refs.recaptcha.reset();
        }
      },
      verifyCaptcha: function (token) {
        this.loadingFeedback();
        this.captcha = !!token;
        this.$emit('submit', {codigo: this.codigoSelo, tipo: this.tipoSelo});
        this.$refs.recaptcha.reset();
      },
      submit: function () {
        if (this.canSubmit)
          this.$refs.recaptcha.execute();
      },
      loadingFeedback: function () {
        let self = this;
        self.loading = true;
        setTimeout(() => {
          self.loading = false;
        }, 2000);
      }
    }
  }
</script>

<style scoped>
  .title.xs {
    margin-bottom: 10px;
  }

  .padded {
    padding-left: 5px;
    padding-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/consulta/FormBuscaSelo.vue